/**
 * Contract shared with the backend's `login_with_work_redirect.html` (and the legacy Ember login
 * app): after the iManage round-trip the popup lands on that page, which writes its own URL —
 * carrying `code` and `state` — to this localStorage key.
 */
export const DMS_LOGIN_STORAGE_KEY = 'cf-dms-login-oauth-code'

export const parseDmsLoginRedirect = (raw: string): { code: string; stateToken: string } | null => {
  try {
    const params = new URL(raw).searchParams
    const code = params.get('code')
    const stateToken = params.get('state')
    return code && stateToken ? { code, stateToken } : null
  } catch {
    return null
  }
}
